import {isWebview} from './is-webview';

// changes the log-out url for mobile apps, android and ios.
export function getReactAppAifgLink() {
    return isWebview() ? 'https://neuralnetwork.aiforgood.itu.int/' : process.env.REACT_APP_AIFG_WP_LINK;
}
